import { useMutation } from '@tanstack/react-query';
import { format } from 'date-fns';
import { posthog } from 'posthog-js';

import { postProjectExpense } from './projectExpenses';
import type { RegisterProjectExpenseFormData } from '@/pages/projects/expenses';
import { createUUID, parseLocaleNumber } from '@/utils';

export const useCreateProjectExpense = () => {
  return useMutation({
    mutationFn: (expenseData: RegisterProjectExpenseFormData) => {
      const expenseGUID = createUUID();

      const mappedPayload = {
        expenseGuid: expenseGUID,
        projectId: Number(expenseData.project_information.project?.id),
        projectSubContractId: expenseData.project_information.contract?.id
          ? Number(expenseData.project_information.contract?.id)
          : null,
        expenseTypeId: Number(expenseData.expense_details.expenseType?.id),
        supplierId: expenseData.expense_details.supplier?.id
          ? Number(expenseData.expense_details.supplier?.id)
          : null,
        supplierInvoiceNo: expenseData.expense_details.supplierInvoiceNumber
          ? expenseData.expense_details.supplierInvoiceNumber
          : null,
        expenseNo: expenseData.expense_details.expenseNumber
          ? expenseData.expense_details.expenseNumber
          : null,
        date: format(expenseData.expense_details.date, 'yyyy-MM-dd'),
        amountIncludingVat: parseLocaleNumber(
          expenseData.expense_details.amountIncludingVat,
        ),
        vatAmount: parseLocaleNumber(expenseData.expense_details.vatAmount),
        paymentMethodId: Number(expenseData.expense_details.paymentMethod?.id),
        comment: expenseData.expense_details.expenseComment || '',
        isBillable: expenseData.expense_details.billable || false,
        currencyCode:
          (expenseData.expense_details.expenseCurrency?.isoCode as string) ??
          '',
        exchangeRate: expenseData.exchangeRate,
        baseReferenceCurrencyCode: expenseData.legalEntityCurrencyIsoCode ?? '',
        fileUrls: expenseData.attachedExpenseFiles,
        profit: parseLocaleNumber(
          expenseData.project_financials.profitPercentage,
        ),
        salesPrice: parseLocaleNumber(
          expenseData.project_financials.billableAmount,
        ),
      };
      return postProjectExpense(mappedPayload);
    },
    onSuccess: (newProjectExpense) => {
      console.debug('Project expense created:', newProjectExpense);
      posthog.capture('project_expense_created');
    },
  });
};
